import React, { Component } from 'react';
import { compose } from 'recompose';

import './CreateQuestion.css';
import { withAuthorization } from '../../../session/index';
import {
    uploadFile,
    uploadFileWithFilePathAndMetadata,
    getDownloadUrlFile,
    deleteFile,
} from '../../../firebase/api/media';

import { formatBytes, ifStringEmpty, randomKey } from '../../../static/utils';
import { populateMetadata } from '../../../static/mediaUtils';
import * as QUESTION from '../../../constants/questions';
import { MAX_FILE_SIZE, NUMBER_OF_IMAGES, POST_MEDIA_ROOT_FOLDER } from '../../../configs';
import ImageCropper from '../../elements/cropper/ImageCropper';

import { Uploader } from '../../elements/files/Uploader';
import { Container, Row, Col, Card, CardHeader } from 'reactstrap';
import { Button } from '../../elements/buttons/Button';
import FilesSection from '../../containers/FilesSection';

import Category from '../../elements/Category/Category';
import { Categories } from '../../../static/categories';
import SubCategory from '../../elements/Category/SubCategory/SubCategory';
import { MAX_TITLE_LENGTH } from '../../../constants/questions';
import { MAX_DESCRIPTION_LENGTH } from '../../../constants/questions';

class CreateOpenQuestionPost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeCategory: null,
            loading: false,
            cropImage: false,
            currentImage: null,
            createPostDTO: {
                title: '',
                description: '',
                category: null,
                inviteColleagues: [],
                inviteAllUsers: false,
                mediaFolder: randomKey(24),
                media: [],
                question: {
                    type: QUESTION.OPEN,
                    questions: [
                        {
                            uid: randomKey(24),
                            title: 'Answer',
                            order: 0,
                            reviews: [],
                        },
                    ],
                },
            },
        };
    }

    componentDidMount() {
        const { post } = this.props;
        if (post) {
            this.setState({ createPostDTO: post, activeCategory: Categories[post.category] });
        }
    }

    categoryToggle = targetCategory => {
        const { createPostDTO, activeCategory } = this.state;
        if (activeCategory) {
            if (activeCategory.uid === targetCategory.uid) {
                createPostDTO.category = null;
                this.setState({ activeCategory: null });
            } else {
                createPostDTO.category = targetCategory.uid;
                this.setState({ activeCategory: targetCategory });
            }
            this.setState({ createPostDTO });
        } else {
            createPostDTO.category = targetCategory.uid;
            this.setState({ createPostDTO, activeCategory: targetCategory });
        }

        // createPostDTO.subCategories.splice(0, createPostDTO.subCategories.length);
        // this.setState({createPostDTO})
    };

    subCategoriesToggle = uid => {
        const { createPostDTO } = this.state;
        const position = createPostDTO.subCategories.indexOf(uid);
        position === -1
            ? createPostDTO.subCategories.push(uid)
            : createPostDTO.subCategories.splice(position, 1);
        this.setState({ createPostDTO });
    };

    onTextInputChange = (event, length) => {
        if (event.target.value.length < length) {
            const createPostDTO = { ...this.state.createPostDTO };
            createPostDTO[event.target.name] = event.target.value;
            this.setState({ createPostDTO });
        }
    };

    deleteFile = index => {
        const { createPostDTO } = this.state;
        if (createPostDTO.media[index]) {
            deleteFile(createPostDTO.media[index].mediaPath);
            createPostDTO.media.splice(index, 1);
        }
        this.setState({
            createPostDTO,
        });
    };

    onDrop = picture => {
        const media = picture.length < 2 ? picture[0] : picture[picture.length - 1];
        this.setState({ currentImage: URL.createObjectURL(media), cropImage: true });
    };

    saveImage = blob => {
        const { createPostDTO } = this.state;
        this.setState({ loading: true });
        const media = blob;

        const metadata = populateMetadata(blob);
        const mediaPath =
            POST_MEDIA_ROOT_FOLDER + createPostDTO.mediaFolder + '/' + randomKey(8) + '.png';

        uploadFileWithFilePathAndMetadata(mediaPath, media, metadata).then(ref => {
            console.log(media);
            getDownloadUrlFile(ref.ref).then(url => {
                const mediaInfo = {
                    downloadMediaUrl: url,
                    mediaPath: mediaPath,
                };
                createPostDTO.media.push(mediaInfo);
                this.setState({ createPostDTO, loading: false });
            });
        });
    };

    cropImageToggle = () => {
        this.setState(prevState => ({
            cropImage: !prevState.cropImage,
        }));
    };

    componentWillUnmount() {
        if (!this.props.isPublished) {
            const media = [...this.state.createPostDTO.media];
            if (media.length > 0) {
                media.map((element, index) => {
                    deleteFile(element.mediaPath);
                });
            }
        }
    }

    render() {
        let { createPostDTO, activeCategory, loading, cropImage, currentImage } = this.state;
        const categoriesKey = Object.keys(Categories);
        return (
            <>
                <Container fluid className="question-card">
                    <div className="mb-5 mt-3">
                        <Row className="explainer p-0 mx-0 mb-3">
                            <b className="explainer d-flex justify-content-center">
                                Post your creative ideas to get advice!
                            </b>
                            <p className="explainer d-flex justify-content-center">
                                Perhaps you want some last minute checks or an extra pair of eyes.
                            </p>
                        </Row>
                        <Row className="d-flex flex-row mx-0">
                            <FilesSection
                                elements={createPostDTO.media}
                                loading={loading}
                                deleteFile={this.deleteFile}
                            />
                            {this.state.createPostDTO.media.length < NUMBER_OF_IMAGES && (
                                <Uploader
                                    buttonText="Upload photo +"
                                    onDrop={this.onDrop}
                                    style={{ background: 'red' }}
                                />
                            )}
                        </Row>
                        <ImageCropper
                            onDrop={this.saveImage}
                            modal={cropImage}
                            toggle={this.cropImageToggle}
                            currentImage={currentImage}
                        />
                    </div>
                </Container>
                <div className="question-type__container m-0 px-0 question-card py-4">
                    <Row className="post-form mx-0 question-type__container">
                        <Col xs={12} md={12} className="px-0">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="title"
                                    className="form-control create-post__title-input"
                                    placeholder="Title/ Question"
                                    value={createPostDTO.title ? createPostDTO.title : ''}
                                    onChange={event =>
                                        this.onTextInputChange(event, MAX_TITLE_LENGTH)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs={12} md={12} className="px-0">
                            <div className="form-group">
                                <textarea
                                    name="description"
                                    rows={8}
                                    className="form-control"
                                    placeholder="Description"
                                    value={
                                        createPostDTO.description ? createPostDTO.description : ''
                                    }
                                    onChange={event =>
                                        this.onTextInputChange(event, MAX_DESCRIPTION_LENGTH)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default CreateOpenQuestionPost;
